<!-- 这个组件废弃 不再用 -->
<template>
  <div :class="rootClass" v-if="!isApp" ref="navigation" :style="{ 'padding-top': (statusBarHeight || 0) + 'px' ,background: theme.background, color: theme.color}">
    <div class="top" ref="top" v-show="debug" :style="{ 'height': statusBarHeight + 'px' }"></div>
    <div class="left" v-if="!adaption">
      <slot name="left">
        <div class="back" v-show="showBack" @click="goBack">
          <div class="arrow-back" :style="{fill: theme.color}">
            <img src="./images/left-button.png" v-if="arrTheme==='black'">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 30" v-else>
              <path fill-rule="evenodd" d="M6.600,15.000 L7.600,14.000 L17.400,4.200 C18.174,3.426 18.174,2.174 17.400,1.399 L17.400,1.399 C16.626,0.626 15.373,0.626 14.599,1.399 L0.001,15.999 L0.001,15.999 L14.599,30.599 C15.373,31.374 16.626,31.374 17.400,30.599 L17.400,30.599 C18.174,29.825 18.174,28.574 17.400,27.799 L7.600,18.000 L6.600,17.000 "></path>
            </svg>

          </div>
        </div>
      </slot>
    </div>

    <div class="center" @click="$emit('center-click')" v-if="!adaption">
      <slot></slot>
    </div>

    <div class="right" @click="$emit('right-click')" v-if="!adaption">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
import router from '../../router'
import { jsBridge } from '@/assets/jsBridge'
import { mapState } from 'vuex'
import { getKey } from '@/assets/utils'
export default {
  name: 'NdNavigation',

  description: '导航',

  data () {
    return {
      isApp: false,
      query: this.$route.query
    }
  },

  props: {
    theme: {
      type: Object,
      default: () => {
        return {
          background: '#fff',
          color: 'black'
        }
      }
    },
    arrTheme: {
      type: String,
      default: 'black'
    },
    showBack: {
      type: Boolean,
      default: true
    },

    onBack: {
      type: Function,
      default: () => {
        const currentPage = location.pathname
        router.go(-1)
        let currentTime = new Date().getTime()
        let frame
        const hack = () => {
          if (new Date().getTime() - currentTime > 200) {
            if (location.pathname === currentPage) {
              jsBridge('exit')
            }
            window.cancelAnimationFrame(frame) 
          } else {
            window.requestAnimationFrame(hack)
          }
        }
                    
        frame = window.requestAnimationFrame(hack)
      }
    },

    // 是否自定义点击事件
    customClickEvent: {
      type: Boolean,
      default: false
    },

    sticky: {
      type: Boolean,
      default: true
    },

    fixed: {
      type: Boolean,
      default: false
    },

    align: {
      type: String,
      default: 'top' // 可选值top，bottom
    },

    debug: { // 在领分期App内跑需要兼容他们状态栏，打开debug可以看到状态栏高度
      type: Boolean,
      default: false
    },

    adaption: { // 不显示只是为了兼容APP
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClass () {
      let cls = ['nd-navigation']
      if (this.fixed) {
        cls.push(`fixed-${this.align}`)
      }
      if (this.sticky) {
        cls.push('sticky')
      }
      if (this.adaption) {
        cls.push('only-adaption')
      }
      return cls
    },

    ...mapState({
      statusBarHeight: state => state.statusBarHeight || getKey('jsBridge', 'statusBarHeight')
    }) 
  },

  methods: {
    goBack () {
      this.$emit('click')
      if (!this.customClickEvent) {
        this.onBack()
      }
    }
  },

  created () {
    if (['API-XHQB', 'API-WEIBO'].includes(getKey('channel')) || this.$route.query.hideNav === 'Y') {
      this.isApp = true
    }
    this.$bus.$on('nativeBack', this.goBack)
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .nd-navigation {
        padding: 0;
        height: 110px;
        justify-content: center;
        box-sizing: content-box;
        align-items: center;
        position: relative;
        display: flex;
        background-color: #FFFFFF;
        z-index: 1000;
        font-size: 36px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        color: @fc1;

        .top {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            background-color: red;
        }

        .left {
          position: absolute;
          left: 0;
            .back {
                height: 80px;
                width: 82px;
                margin:0;
                display: flex;
                justify-content:center;
                align-items: center;
                .arrow-back {
                    height: 39px;
                    width: 22px;
                    fill: @fc1;
                    >img{
                        height: 39px;
                        width: 22px;
                    }
                }
            }
        }

        .right {
            font-weight: normal;
            position: absolute;
            font-size: 32px;
            right: 30px;
        }
        
        .center {
            text-align: center;
            font-weight: bold;
        }

        &.transparent {
            background-color: transparent!important;
            border-bottom: none;
        }

        &.white {
            color: #FFFFFF;

            .left {
                .arrow-back {
                    fill: #FFFFFF;
                }
            }

            .center {
                color: #FFFFFF;
            }
        }

        &.fixed-top {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
        }

        &.fixed-bottom {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }

        &.sticky {
            position: sticky;
            top: 0;
        }

        &.only-adaption {
            height: 0;
            z-index: 0;
        }
    }
</style>